export default __webpack_public_path__ + "static/media/arrow-down.1b8ef2f2.svg";